import apiClient from "./config";
import { CHAT_ENDPOINTS } from "./endpoints";

export const getDirectContact = () => apiClient.get(CHAT_ENDPOINTS.GET_DIRECT_CONTACT);
export const getMessages = (roomId) => apiClient.get(`${CHAT_ENDPOINTS.GET_MESSAGES}/${roomId}`, { params: { roomId } });
export const addMessage = (message) => apiClient.create(CHAT_ENDPOINTS.ADD_MESSAGE, message);
export const deleteMessage = (message) => apiClient.delete(CHAT_ENDPOINTS.DELETE_MESSAGE, { headers: { message } });
export const getChannels = () => apiClient.get(CHAT_ENDPOINTS.GET_CHANNELS);

